<template>
    <div>
        <van-nav-bar :title="title" ></van-nav-bar>
        <div class="fin-panel" >
            <van-cell-group >
                <van-field
                        readonly
                        clickable
                        label="账单类型"
                        :value="billType"
                        placeholder="请选择"
                        @click="showBillTypePicker = true"

                />
                <van-popup v-model="showBillTypePicker" position="bottom">
                    <van-picker show-toolbar title="账单类型" ref="billTypePicker"
                                :columns="billTypes"
                                value-key="attrName"
                                @cancel="showBillTypePicker = false"
                                @confirm="onBillTypeConfirm"/>
                </van-popup>
            </van-cell-group>

            <!--     分期型数据展示分期数据       -->
            <van-cell-group v-if="overdraftArr.indexOf(formModel.billType+'') != -1">
                <van-field
                        label="分期数"
                        readonly
                        clickable
                        :value="formModel.instalmentsCnt"
                        @touchstart.native.stop="instalmentsCntShow = true"
                />
                <van-number-keyboard
                        v-model="formModel.instalmentsCnt"
                        :show="instalmentsCntShow"
                        :maxlength="6"
                        close-button-text="完成"
                        @blur="instalmentsCntShow = false"
                />
            </van-cell-group>

            <van-cell-group >
                <van-field
                        readonly
                        clickable
                        label="账单状态"
                        :value="billStatus"
                        placeholder="请选择"
                        @click="showBillStatusPicker = true"

                />
                <van-popup v-model="showBillStatusPicker" position="bottom">
                    <van-picker show-toolbar title="账单状态" ref="billStatusPicker"
                                :columns="billStatusList"
                                value-key="attrName"
                                @cancel="showBillStatusPicker = false"
                                @confirm="onBillStatusConfirm"/>
                </van-popup>
            </van-cell-group>

            <!--     储值型数据展示转结账单       -->
            <van-cell-group v-if="storeArr.indexOf(formModel.billType+'') != -1">
                <van-field
                        readonly
                        clickable
                        label="转结账单"
                        :value="turnKnotName"
                        placeholder="请选择"
                        @click="showTurnKnotPicker = true"

                />
                <van-popup v-model="showTurnKnotPicker" position="bottom">
                    <van-picker show-toolbar title="转结账单" ref="turnKnotPicker"
                                :columns="turnKnotList"
                                value-key="finName"
                                @cancel="onTurnKnotCancel"
                                @confirm="onTurnKnotConfirm"/>
                </van-popup>
            </van-cell-group>

            <van-cell-group>
                <van-field
                        v-model="formModel.remark"
                        rows="2"
                        autosize
                        label="备注"
                        type="textarea"
                        maxlength="50"
                        placeholder="请输入备注"
                        show-word-limit
                />

            </van-cell-group>

            <van-button style="margin-top: 10px;" type="primary"
                        block round color="#fe7844" :loading="isLoading"
                        loading-text="提交中..."
                        @click="submitForm">提交</van-button>


        </div>
    </div>
</template>

<script>
    import {formatDate,stringToDate} from '../../common/utils/dateUtil.js'
    import * as MyApi from '../../api/URLApiAddr.js'
    import * as BusiConsts from '../../common/BusiConsts.js'

    export default {
        name: 'MyFinance',
        components: {
        },
        data() {
            return {
                title: '在途修改',
                active: [],
                isLoading: false,
                formModel:{
                    finId: this.$route.params.finId,
                    remark: '',
                    billType: '',
                    billStatus: '',
                    instalmentsCnt: '',
                    turnKnotId: '' //转结id
                },
                month:this.$route.params.month,
                billType: '',
                billTypes: [],
                showBillTypePicker: false,
                billStatus: '',
                billStatusList: [],
                showBillStatusPicker: false,
                instalmentsCntShow: false,
                turnKnotName: '',
                turnKnotList: [],
                showTurnKnotPicker: false,
                turnKnotShow: false,
                overdraftArr: [BusiConsts.BILL_TYPE_OVERDRAFT,BusiConsts.BILL_TYPE_OVERDRAFT_STORE],//分期型类型
                storeArr:[BusiConsts.BILL_TYPE_OVERDRAFT_STORE,BusiConsts.BILL_TYPE_STORED_VALUE] //储值型类型
            }
        },
        created:function() {
            this.initAlterData()
        },
        methods:{

            initAlterData(){
                debugger
                let finId = this.formModel.finId
                let params = {finId:finId}
                this.$axios.post(MyApi.QRY_FIN_DETAIL,params/*,options*/)
                // 请求成功后
                    .then((response) => {

                        let data = response.data;
                        let bt = data.attrSepc.billType
                        let bs = data.attrSepc.billStatus
                        let finance = data.finance

                        this.billTypes.push({values:bt,defaultIndex:data.initIndex[3]})
                        this.billType = finance.billTypeName
                        this.formModel.billType = finance.billType

                        this.billStatusList.push({values:bs,defaultIndex:data.initIndex[4]})
                        this.billStatus = finance.billStatusName
                        this.formModel.billStatus = finance.billStatus
                        this.formModel.instalmentsCnt = finance.instalmentsCnt + ''

                        this.formModel.remark = finance.remark + '';
                        //如果是储值类型,转结选项才展示
                        //this.showTurnKnot(finance.billType)
                        // if(BusiConsts.BILL_TYPE_STORED_VALUE == finance.billType){
                        //     this.turnKnotShow = true
                        // }else{
                        //     this.turnKnotShow = false
                        // }


                    })
                    .catch((err) => {
                        console.log(err)
                        this.$toast.fail("请求异常,请稍后再试" + e);
                    })
                //查询在途账单列表
                this.$axios.post(MyApi.QRY_TRANS_FIN_LIST,params).then((response) => {
                    let data = response.data
                    if(data.length > 0){
                        //this.formModel.turnKnotId = data[0].finId
                        //this.turnKnotName = data[0].finName
                        this.turnKnotList.push({values:data});
                    }
                }).catch((error) => {
                    // eslint-disable-next-line no-console
                    console.log(error)
                    this.$toast.fail("在途列表数据初始化异常");
                })

            },
            onBillTypeConfirm(value){
                this.formModel.billType = value[0].attrId;
                //this.showTurnKnot(value[0].attrId)
                this.billType = value[0].attrName ;
                this.showBillTypePicker = false
            },
            onBillStatusConfirm(value){
                this.formModel.billStatus = value[0].attrId;
                this.billStatus = value[0].attrName ;
                this.showBillStatusPicker = false
            },
            submitForm() {
                this.isLoading = true
                // let params = this.model
                // thisVue.buttonDisabled = true
                //let toast = thisVue.showToast()

                debugger;
                let params = this.formModel
                this.$axios.post(MyApi.FINANCE_SAVE_URL,params/*,options*/)

                // 请求成功后
                    .then((data) => {
                        //let data = response.data;
                        if('200' == data.code){
                            if(this.month){
                                this.$router.push({ name:'finList',params:{month:this.month} })
                            }
                            this.formModel.amount = ''
                            this.formModel.remark = ''
                            this.$toast.success(data.msg);
                        }
                        this.isLoading = false
                    })
                    .catch((err) => {
                        this.$toast.fail("请求异常,请稍后再试");
                    })
            },
            onTurnKnotConfirm(value){
                this.formModel.turnKnotId = value[0].finId;
                this.turnKnotName = value[0].finName ;
                this.showTurnKnotPicker = false
            },
            onTurnKnotCancel(){
                this.formModel.turnKnotId = ''
                this.turnKnotName = ''
                this.showTurnKnotPicker = false
            }

        }

    };
</script>



<style>
    .fin-panel {
        min-width: 120px;
        font-size: 20px;
        line-height: 36px;
        margin-left: 15px;
        margin-right: 15px;
        margin-bottom: 60px;
    }

</style>
